import Logger from 'wanderu-logger';

import { actions as stateGuideActions } from '../../appstate/placeGuide';
import { getStateGuideContent } from '../../services/seoService';
import {
    actions,
    reducer,
    selectors,
    namespace,
} from './base';

const logger = Logger.getLogger('fetchStateGuide');

function fetchStateGuide(localeAwareStateGuideId, country, state, transMode, locale) {
    return async function(dispatch) {
        let error = null;

        dispatch(actions.startWork(localeAwareStateGuideId));

        try {
            const { result } = await getStateGuideContent({
                locale,
                country,
                state,
                transMode,
            });

            dispatch(stateGuideActions.setPlaceGuideContent(result, localeAwareStateGuideId));
            return result;
        } catch (ex) {
            logger.error('fetch', ex, {
                country,
                locale,
                localeAwareStateGuideId,
                state,
                transMode,
            });

            error = {
                code: ex.code,
                message: 'set state guide failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(localeAwareStateGuideId, undefined, error));
        }
    };
}

const fetchStateGuideSelectors = {
    ...selectors,
    selectNotFound(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && opStatus.error.code === 'INVALID_STATE_GUIDE';
    },
};

const fetchStateGuideAction = {
    fetchStateGuide,
    ...fetchStateGuideSelectors,
};

export {
    fetchStateGuideAction,
    namespace,
};

export default {
    [namespace]: reducer,
};
